<template>
    <div class="section-images-grid">
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].cards" :key="item.title">
                <div class="item-desc">
                    <h4 v-html="item.title"></h4>
                    <p v-html="item.desc"></p>
                </div>
                <div class="item-img" :style="'background-image:url(' + item.img + ')'" v-if="!isMobileGlobal"></div>
            </div>
        </div>
        <div class="grid-img" :style="'background-image:url(' + options[0].grid_img + ')'" v-if="!isMobileGlobal"></div>
        
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'section-images-grid',
        props: ['options'],
        data () {
            return {
            }
        },
        computed: mapGetters({
            isMobileGlobal: 'loadisMobileGlobal',
        }),
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/section-images-grid.scss';
    @import '@/styles/components/partials/respond/section-images-grid-respond.scss';
</style>